import { Pipe, PipeTransform } from "@angular/core";
import { parseNumber } from "../helpers/helper";
import { ModuleProductPricingConfigRoundingRuleExample, ModuleProductPricingConfigRoundingRuleMethod } from "../interfaces/interfaces";

function applyRoundingRule(inputNumber: number, digitCount: number, roundingPoint: number, method: ModuleProductPricingConfigRoundingRuleMethod): number {

    // GET DECIMAL COUNT
    let decimalCount: number = 0;
    const inputNumberParts: string[] = inputNumber.toString().split('.');
    if (inputNumberParts.length > 1) {
        decimalCount = inputNumberParts[1].length;
    }

    // GET A NUMBER WITHOUT FRACTIONS
    inputNumber *= Math.pow(10, decimalCount);
    
    // GET ROUNDING NUMBER
    roundingPoint *= Math.pow(10, decimalCount + digitCount);

    let endOfInputString: string = inputNumber.toString().substr(-(decimalCount + digitCount));
    const inputNumberEnd: number = parseNumber(endOfInputString);
    if (inputNumberEnd <= roundingPoint) {
        inputNumber -= Math.pow(10, decimalCount + digitCount);
    }
    switch (method) {
        case ModuleProductPricingConfigRoundingRuleMethod.ZERO:
            endOfInputString = '0'.repeat(decimalCount + digitCount);
            break;
        case ModuleProductPricingConfigRoundingRuleMethod.NINES:
            endOfInputString = '9'.repeat(decimalCount + digitCount);
            break;
        case ModuleProductPricingConfigRoundingRuleMethod.NINE:
            endOfInputString = ['9', '0'.repeat(decimalCount + digitCount - 1)].join('');
            break;
    }

    let finalNumber: number = parseNumber(inputNumber.toString().substr(0, inputNumber.toString().length - endOfInputString.length) + endOfInputString);
    if (decimalCount > 0) {
        finalNumber /= Math.pow(10, decimalCount);
    }
    return finalNumber;
}

@Pipe({
    name: 'roundingrule',
    pure: false
})
export class RoundingRulePipe implements PipeTransform {
    transform(input: any, roundingRule: ModuleProductPricingConfigRoundingRuleExample): string {
        let inputNumber: number = parseNumber(input, NaN);
        let roundingPoint: number = parseNumber(roundingRule.roundingPoint, NaN);
        if (isNaN(inputNumber) || isNaN(roundingPoint)) {
            return '-';
        }
        return applyRoundingRule(inputNumber, roundingRule.digitCount, roundingPoint, roundingRule.method).toString();
    }
}